'use strict';

var ScrollTopDirective = function () {
  var link = function postLink(scope, elem) {
      scope.$watch('trigger', function() {
        angular.element(elem)[0].parentElement.scrollTop = 0;
      });
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    restrict: 'A',
    link: link,
    scope: {
      trigger: '=scrollToTop'
    }
  };
};

module.exports = ScrollTopDirective;


// WEBPACK FOOTER //
// ./src/app/manager/directives/ScrollTopDirective.js